import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class NegateAccessGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isFuncionario()) {
      // Se o usuário é funcionário, redireciona para o Dashboard
      this.router.navigate(['/']);
      return false; // Impede o acesso ao "Acesso Negado"
    }
    return true; // Permite acesso caso não seja funcionário
  }
}
